// IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення)
// Круговая диаграмма по статусам документов в ячейке-дате отчёта (AttrGrid, вид «status_pie» опции среза). Бэк (хвост doc_links) кладёт в ячейку-дату
// спутник st_val = { "<статус>": { "<мера>": <число> } } рядом с doc_ids / doc_qty / doc_st; мера ячейки — суффикс привязки колонки `YYYY-MM-DD.<мера>`.
// Сектора — суммы меры по статусам; остаток «без документа» = значение ячейки − Σ по статусам (> 0 — нейтральный сектор «No document»); пустой статус "" —
// «No status». Цвета статусов — по палитре статусов платформы (пилюли applyStatusChip / записи STATUS: work / confirmed — зелёный, waiting / todo — жёлтый,
// error — оранжевый, done — серый …), прочие — категориальная палитра по хешу ключа, «No document» — светло-серый. Фон — CSS conic-gradient (heatmap_pie
// вкладки Heatmap), без SVG / canvas на ячейку. Чистые функции (без Vue и DOM) — tests/unit/cellPie.test.mjs.
// Выключатель fe.ux.cellStatusPie (по умолчанию ВКЛ): ВЫКЛ — кнопка вида работает как обычная опция среза (toggle_option_group на бэк), пирогов нет
import { t as tI18n } from '@/i18n'
import { heatmap_pie, heatmap_share_pct } from '@/utils/heatmapMatrix'
import { hmTip_esc } from '@/utils/heatmapTip'

export const CELL_PIE_FLAG = 'fe.ux.cellStatusPie'
export const CELL_PIE_VIEW = 'status_pie'
export const CELL_PIE_NODOC = '\u0000nodoc'   // ключ сектора-остатка (не пересекается со статусами бэка)

export function cellPie_flagOn(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CELL_PIE_FLAG, true) !== false : true } catch (e) { return true }
}

// кнопка опции вида, которую фронт переключает сам (контракт set_menu: view + front_only)
export function cellPie_isViewButton(btn) {
    return !!(btn && typeof btn === 'object' && btn.view && btn.front_only)
}

// палитра статусов платформы (насыщеннее пастели пилюль — сектор в 12–14 px должен читаться)
export const CELL_PIE_COLORS = {
    green: '#43a047', yellow: '#f9a825', orange: '#ef6c00', red: '#e53935', grey: '#9e9e9e', blue: '#1e88e5', bluegrey: '#90a4ae',
    nodoc: '#e0e0e0', nostatus: '#b0bec5',
}
const STATUS_TONE = {
    work: 'green', start: 'green', stop: 'green', confirmed: 'green', ok: 'green', approved: 'green', posted: 'green', active: 'green',
    waiting: 'yellow', todo: 'yellow', interrupted: 'yellow', scheduled: 'yellow', warning: 'yellow', autoplan: 'yellow', planned: 'yellow', pending: 'yellow',
    error: 'orange', failed: 'orange',
    uncovered: 'red', rejected: 'red',
    done: 'grey', end: 'grey', closed: 'grey', cancel: 'grey', cancelled: 'grey', canceled: 'grey',
    draft: 'bluegrey', new: 'blue', sent: 'blue', info: 'blue',
}
// категориальная палитра прочих статусов (сырые статусы 1С и т. п.) — без зелёного / жёлтого / оранжевого / серого платформенных тонов
const CAT_PALETTE = ['#5c6bc0', '#26a69a', '#ab47bc', '#8d6e63', '#29b6f6', '#ec407a', '#7cb342', '#ffa726', '#7e57c2', '#00838f']

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }

// 'statusDoc-confirmed' / 'STATUS-work' / 'Confirmed' → 'confirmed'
export function cellPie_statusKey(s) {
    return str(s).replace(/^(statusDoc|STATUS)-/i, '').toLowerCase()
}

function hash(s) { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return Math.abs(h) }

// IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe — цвета статусов из палитры бэка stats.palette)
// палитра бэка из ответа (select / select_cell_views: stats.palette = { <ключ статуса>: { color: '#rrggbb', title, … } }) → запись по ключу: как есть, затем без регистра
export function cellPie_paletteEntry(palette, status) {
    if (!palette || typeof palette !== 'object' || Array.isArray(palette)) return null
    const raw = (status === null || status === undefined) ? '' : String(status)
    const ok = (e) => (e && typeof e === 'object' && !Array.isArray(e)) ? e : null
    if (Object.prototype.hasOwnProperty.call(palette, raw) && ok(palette[raw])) return palette[raw]
    const low = raw.trim().toLowerCase()
    if (!low) return null
    for (const k of Object.keys(palette)) if (k.trim().toLowerCase() === low && ok(palette[k])) return palette[k]
    return null
}
// цвет статуса: палитра бэка (если есть и цвет непустой), иначе прежнее поведение фронта
export function cellPie_color(status, palette) {
    if (status === CELL_PIE_NODOC) return CELL_PIE_COLORS.nodoc
    const pe = cellPie_paletteEntry(palette, status)
    const pc = pe && str(pe.color)
    if (pc && /^#[0-9a-f]{3,8}$/i.test(pc)) return pc   // только #hex (цвет уходит в style подсказки)
    const k = cellPie_statusKey(status)
    if (!k) return CELL_PIE_COLORS.nostatus
    const tone = STATUS_TONE[k]
    return tone ? CELL_PIE_COLORS[tone] : CAT_PALETTE[hash(k) % CAT_PALETTE.length]
}

export function cellPie_title(status, t = tI18n, palette) {
    const tt = typeof t === 'function' ? t : (x) => x
    if (status === CELL_PIE_NODOC) return tt('No document')
    const pe = cellPie_paletteEntry(palette, status)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe — цвета статусов из палитры бэка stats.palette)
    if (pe && str(pe.title)) return str(pe.title)
    const raw = str(status).replace(/^(statusDoc|STATUS)-/i, '')
    if (!raw) return tt('No status')
    return tt(raw.charAt(0).toUpperCase() + raw.slice(1))
}

// привязка колонки → { date, measure } (только ячейка-дата `YYYY-MM-DD.<мера>`), иначе null
export function cellPie_bindingOf(binding) {
    const m = /^(\d{4}-\d{2}-\d{2})\.(.+)$/.exec(str(binding))
    return m ? { date: m[1], measure: m[2] } : null
}

// сектора ячейки: stVal — спутник st_val, measure — мера ячейки, cellValue — значение ячейки (число; нет — без остатка).
// → { sectors: [{ key, title, value, share, color }], sum, value } по убыванию значения (остаток «No document» — последним) либо null
// (нет спутника / меры / положительных сумм). share — доля среди положительных секторов
export function cellPie_sectors(stVal, measure, cellValue, opts = {}) {
    if (!stVal || typeof stVal !== 'object' || Array.isArray(stVal)) return null
    const ms = str(measure)
    if (!ms) return null
    const t = opts.t || tI18n
    const list = []
    let sum = 0, any = false
    for (const st of Object.keys(stVal)) {
        const byM = stVal[st]
        if (!byM || typeof byM !== 'object' || !Object.prototype.hasOwnProperty.call(byM, ms)) continue
        const v = num(byM[ms])
        any = true
        sum += v
        if (v > 0) list.push({ key: st, title: cellPie_title(st, t, opts.palette), value: v, color: cellPie_color(st, opts.palette) })   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe): палитра бэка
    }
    if (!any || !list.length) return null   // ни одного статуса с положительной суммой (возвраты, нули) — пирога нет
    list.sort((a, b) => b.value - a.value)
    const hasCv = cellValue !== null && cellValue !== undefined && cellValue !== '' && Number.isFinite(Number(cellValue))
    const cv = hasCv ? Number(cellValue) : sum
    if (hasCv) {
        const rest = cv - sum
        const eps = Math.max(1e-9, Math.abs(cv) * 1e-9)
        if (rest > eps) list.push({ key: CELL_PIE_NODOC, title: cellPie_title(CELL_PIE_NODOC, t), value: rest, color: CELL_PIE_COLORS.nodoc })
    }
    const pos = list.reduce((s, c) => s + c.value, 0)
    if (!(pos > 0)) return null
    for (const c of list) c.share = c.value / pos
    return { sectors: list, sum, value: cv }
}

// фон пирога: несколько цветов — conic-gradient (heatmap_pie), один — сплошной цвет; нет секторов — ''
export function cellPie_background(pie) {
    const sec = pie && Array.isArray(pie.sectors) ? pie.sectors : []
    if (!sec.length) return ''
    const colors = new Map(sec.map(s => [s.key, s.color]))
    return heatmap_pie(sec, (k) => colors.get(k)) || sec[0].color
}

// Alt-подсказка пирога — в стиле подсказки пузыря Heatmap (hm-tip: группа «название … значение», цветные метки)
// opts: { t, fmt, head } — перевод, формат числа, заголовок (строка / мера / период)
export function cellPie_tipHtml(pie, opts = {}) {
    const sec = pie && Array.isArray(pie.sectors) ? pie.sectors : []
    if (!sec.length) return ''
    const t = typeof opts.t === 'function' ? opts.t : tI18n
    const fmt = typeof opts.fmt === 'function' ? opts.fmt : (v) => String(v ?? '')
    const rows = sec.map(s => `<span class="hm-tip-k"><i class="hm-tip-sw" style="background:${s.color}"></i><span class="hm-tip-kt">${hmTip_esc(s.title)}</span></span>`
        + `<span class="hm-tip-v">${hmTip_esc(fmt(s.value))} <span class="hm-tip-vs">${hmTip_esc(heatmap_share_pct(s.share))}</span></span>`).join('')
    const head = str(opts.head)
    return `<div class="hm-tip hm-tip-g cell-pie-tip">`
        + `<div class="hm-tip-head">${head ? `<div class="hm-tip-title">${hmTip_esc(head)}</div>` : ''}<div class="hm-tip-sub">${hmTip_esc(t('Cell value'))}: ${hmTip_esc(fmt(pie.value))}</div></div>`
        + `<div class="hm-tip-sec"><div class="hm-tip-cap">${hmTip_esc(t('By document status'))}</div>${rows}</div></div>`
}
